import { useContext } from "react";
import SentimentDriversTable from "../../../Component/BrandIndexHistory/SentimentDrivers";
import { transformDriverData } from "../../../utils/helpers";
import { DiscoveryContext } from "../discovery-context";
import { Skeleton } from "@mui/material";
import { AuthContext } from "../../../context/auth-context";

export default function SentimentDrivers({
  selectedCompetitor = 0,
  isSelectedMarket = false,
  id = "Sentiment_Drivers"
}) {

  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const selectedLLM = discoveryCtx?.state.selectedLLM;
  const selectedCategory = discoveryCtx?.state.selectedCategory;
  const selectedMarket = discoveryCtx?.state.selectedMarket;
  const selectedPersona = discoveryCtx?.state.selectedPersona;
  const isCompanyUser = user?.user_role?.role?.name === "Company user";
  let market = discoveryCtx?.markets[0];
  let data = {};
  let loading = true;
  function LoadingSkeletion() {
    return (
      <div className="p-3">
        <Skeleton variant="rectangular" height={30} />
        {Array(10)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              variant="rectangular"
              width={index % 2 === 0 ? "70%" : "97%"}
              key={index}
              className="my-3"
              height={20}
            />
          ))}
      </div>
    );
  }

  if (selectedCategory) {
    if (isSelectedMarket) {
      data =
        discoveryCtx?.brand_scores[selectedLLM]?.[selectedCategory]?.[
          selectedMarket
        ]?.[selectedPersona]?.[0]?.extras;
    } else {
      data =
        discoveryCtx?.brand_scores[selectedLLM]?.[selectedCategory]?.[selectedMarket]?.[selectedPersona]?.[
          selectedCompetitor
        ]?.extras;
    }
  }

  if (data?.sentiementKeyDrivers &&
    Object.keys(data.sentiementKeyDrivers).length > 0) {
    loading = false;
  }

  return (
    <>
      {!loading && (
          <>
            <hr />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.5rem",
              }}
              id={id}
            >
              {data?.sentiementKeyDrivers?.positive &&
                data.sentiementKeyDrivers?.positive.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }} >
                    <SentimentDriversTable
                      data={transformDriverData(
                        data.sentiementKeyDrivers?.positive,
                        "Positive"
                      )}
                      title={discoveryCtx?.mapMetricTitle?.("Positive Sentiment Drivers") ?? "Positive Sentiment Drivers"}
                      id="positive_drivers"
                      driverType="positive"
                      sentimentData={data}
                      showInfoIcon={!isCompanyUser}
                    />
                  </div>
                )}

              {data?.sentiementKeyDrivers?.negative &&
                data.sentiementKeyDrivers?.negative.length > 0 && (
                  <div style={{ flex: 1, minWidth: "40%" }}>
                    <SentimentDriversTable
                      data={transformDriverData(
                        data.sentiementKeyDrivers?.negative,
                        "Negative"
                      )}
                      title={discoveryCtx?.mapMetricTitle?.("Negative Sentiment Drivers") ?? "Negative Sentiment Drivers"}
                      id="negative_drivers"
                        driverType="negative"
                        sentimentData={data}
                        showInfoIcon={!isCompanyUser}
                    />
                  </div>
                )}
            </div>
          </>
        )}
      {loading && <LoadingSkeletion />}

    </>
  );
}
